import React from 'react';
import * as BiIcon from 'react-icons/bi';
import * as MdIcon from 'react-icons/md';
// import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import {Route} from 'react-router-dom';
import Dashboard from '../../pages/Dashboard/Dashboard';
import ReviewTask from '../../pages/ReviewTask/ReviewTask';
// import ReviewResult from "../../pages/ReviewResult/ReviewResult";
import ReviewQuestion from '../../pages/ReviewTask/ReviewQuestion';
import Consolidation from '../../pages/Consolidation/Consolidation';
import ConsolidatedReviews from '../../pages/Consolidation/ConsolidatedReviews';
import ConsolidationReview from '../../pages/Consolidation/ConsolidationReview';
import ConsolidationView from '../../pages/Consolidation/ConsolidationView';
import ConsolidationTable from '../../pages/Consolidation/ConsolidationTable';
import Scoring from '../../pages/Consolidation/Scoring';
import ReviewAssignment from '../../pages/Assignment/ReviewAssignment';
import ManageAssignment from '../../pages/Assignment/ManageAssignment';
import ViewGeneralQuestions from '../../pages/ManageQuestion/ViewGeneralQuestions';
import ViewSkills from '../../pages/ManageQuestion/ViewSkills';
import UserAuthentication from '../../pages/UserAuthentication/UserAuthentication';
import ManageRoleLevel from '../../pages/Management/ManageRoleLevel';
import ManageCompany from '../../pages/ManageCompany/ManageCompany';
import ManagePractices from '../../pages/Management/ManagePractices';
import ManageProjects from '../../pages/Management/ManageProjects';
import ManagePeriods from '../../pages/Management/ManagePeriods';
import ManageOffice from '../../pages/Management/ManageOffice';
import ManageEmployee from '../../pages/ManageEmployee/ManageEmployee';
import TeamAssignment from '../../pages/Assignment/TeamAssignment';
import {EMenuId, EPathname} from '../../const/dataEnum';
import {FmlxIcon} from 'fmlx-common-ui';
import ManageDepartmentRole from '../../pages/ManageDepartmentRole/ManageDepartmentRole';
import MessageInbox from '../../pages/Management/MessageInbox';
import FeedbackReview from '../../pages/FeedbackReview/FeedbackReview';
// import { ConsoleLog } from "../../lib/ConsoleHelper";

/* // this page is not use anymore
<Route path="/ReviewResultDetail" component={ReviewResultDetail} />

<Route path="/ReviewResultDetail" component={() => ChangeHeader("Review Detail")} />
*/

export function ChangeHeader(name) {
  return <div className="title">{name}</div>;
}

export const MenuData = [
  {
    id: EMenuId.DASHBOARD,
    parentId: null,
    orderNumber: 1,
    text: 'Home',
    pageTitle: 'Dashboard',
    type: 'icon-text',
    path: EPathname.DASHBOARD,
    icon: <FmlxIcon name="Home"/>,
    route: <Route path={EPathname.DASHBOARD} exact component={Dashboard}/>,
    routeMenu: <Route path={EPathname.DASHBOARD} exact component={() => ChangeHeader('Home')}/>,
  },
  {
    id: EMenuId.REVIEW_TASK,
    parentId: null,
    orderNumber: 2,
    text: 'Review',
    pageTitle: 'Review',
    path: EPathname.REVIEW_TASK,
    type: 'icon-text',
    icon: <FmlxIcon name="Task"/>,
    route: (
      <>
        <Route path={EPathname.REVIEW_TASK} component={ReviewTask}/>
        <Route path={EPathname.REVIEW_QUESTION} component={ReviewQuestion}/>
      </>
    ),
    routeMenu: <Route path={EPathname.REVIEW_TASK} component={() => ChangeHeader('Review Task')}/>,
  },
  // {
  //   id: EMenuId.REVIEW_RESULT,
  //   parentId: null,
  //   orderNumber: 3,
  //   type: 'icon-text',
  //   text: "Review Result",
  //   pageTitle: "Review Result",
  //   path: EPathname.REVIEW_RESULT,
  //   icon: <FmlxIcon name="Chart" />,
  //   route: <Route path={EPathname.REVIEW_RESULT} component={ReviewResult} />,
  //   routeMenu: <Route path={EPathname.REVIEW_RESULT} component={() => ChangeHeader("Review Result")} />,
  // },
  {
    id: EMenuId.MANAGE_REVIEW,
    orderNumber: 4,
    parentId: null,
    type: 'icon-text',
    text: 'Manage Review',
    pageTitle: null,
    icon: <FmlxIcon name="Editor"/>,
    route: null,
    routeMenu: null,
  },
  {
    id: EMenuId.MASTER_DATA,
    orderNumber: 5,
    parentId: null,
    type: 'icon-text',
    text: 'Master Data',
    pageTitle: null,
    icon: <FmlxIcon name="Column"/>,
    route: null,
    routeMenu: null,
  },
  {
    id: EMenuId.CONSOLIDATION,
    orderNumber: 5,
    parentId: EMenuId.MANAGE_REVIEW,
    description: '',
    type: 'icon-text',
    text: 'Consolidation',
    pageTitle: 'Consolidation',
    path: EPathname.CONSOLIDATION,
    icon: null,
    route: (
      <>
        <Route path={EPathname.CONSOLIDATION} component={Consolidation}/>
        <Route path={EPathname.CONSOLIDATION_REVIEW} component={ConsolidationReview}/>
      </>
    ),
    routeMenu: <Route path={EPathname.CONSOLIDATION} component={() => ChangeHeader('Consolidation')}/>,
  },
  {
    id: EMenuId.CONSOLIDATED_REVIEW,
    orderNumber: 6,
    parentId: EMenuId.MANAGE_REVIEW,
    description: '',
    text: 'Consolidated Review',
    pageTitle: 'Consolidated Review',
    path: EPathname.CONSOLIDATED_REVIEW,
    icon: null,
    route: (
      <>
        <Route path={EPathname.CONSOLIDATED_REVIEW} component={ConsolidatedReviews}/>
        <Route path={EPathname.CONSOLIDATION_VIEW} component={ConsolidationView}/>
      </>
    ),
    routeMenu: <Route path={EPathname.CONSOLIDATED_REVIEW} component={() => ChangeHeader('Consolidated Reviews')}/>,
  },
  {
    // Deprecated
    id: 0,
    orderNumber: 0,
    parentId: null,
    type: 'icon-text',
    text: 'Consolidation Table',
    pageTitle: 'Consolidation Table',
    path: EPathname.CONSOLIDATION_TABLE,
    icon: <BiIcon.BiTable/>,
    route: <Route path={EPathname.CONSOLIDATION_TABLE} component={ConsolidationTable}/>,
    routeMenu: <Route path={EPathname.CONSOLIDATION_TABLE} component={() => ChangeHeader('Consolidation Table')}/>,
  },
  {
    // Deprecated
    id: 0,
    orderNumber: 0,
    parentId: null,
    type: 'icon-text',
    text: 'Scoring',
    pageTitle: 'Scoring',
    path: EPathname.SCORING,
    icon: <BiIcon.BiStar/>,
    route: <Route path={EPathname.SCORING} component={Scoring}/>,
    routeMenu: <Route path={EPathname.SCORING} component={() => ChangeHeader('Scoring')}/>,
  },
  {
    // Deprecated
    id: EMenuId.REVIEW_ASSIGNMENT,
    orderNumber: 7,
    parentId: EMenuId.MANAGE_REVIEW,
    description: '',
    text: 'Review Assignment',
    path: EPathname.REVIEW_ASSIGNMENT,
    pageTitle: 'Review Assignment',
    icon: <MdIcon.MdAssignmentInd/>,
    route: <Route path={EPathname.REVIEW_ASSIGNMENT} component={ReviewAssignment}/>,
    routeMenu: <Route path={EPathname.REVIEW_ASSIGNMENT} component={() => ChangeHeader('Review Assignment')}/>,
  },
  {
    id: EMenuId.MANAGE_ASSIGNMENT,
    orderNumber: 8,
    parentId: EMenuId.MANAGE_REVIEW,
    description: '',
    text: 'Assignment',
    pageTitle: 'Manage Assignment',
    path: EPathname.MANAGE_ASSIGNMENT,
    icon: null,
    route: <Route path={EPathname.MANAGE_ASSIGNMENT} component={ManageAssignment}/>,
    routeMenu: <Route path={EPathname.MANAGE_ASSIGNMENT} component={() => ChangeHeader('Manage Assignment')}/>,
  },
  {
    id: EMenuId.REVIEW_FEEDBACK,
    orderNumber: 23,
    parentId: EMenuId.MANAGE_REVIEW,
    description: '',
    text: 'Feedback from Team',
    pageTitle: 'Feedback from Team',
    path: EPathname.REVIEW_FEEDBACK,
    icon: null,
    route: <Route path={EPathname.REVIEW_FEEDBACK} component={FeedbackReview}/>,
    routeMenu: <Route path={EPathname.REVIEW_FEEDBACK} component={() => ChangeHeader('Feedback from Team')}/>,
  },
  {
    id: EMenuId.MANAGE_QUESTION,
    orderNumber: 16,
    parentId: EMenuId.MASTER_DATA,
    description: '',
    text: 'Question',
    pageTitle: 'Manage Question',
    path: EPathname.MANAGE_QUESTION,
    icon: null,
    route: <Route path={EPathname.MANAGE_QUESTION} component={ViewGeneralQuestions}/>,
    routeMenu: <Route path={EPathname.MANAGE_QUESTION} component={() => ChangeHeader('Manage Question')}/>,
  },
  {
    // Deprecated
    id: EMenuId.MANAGE_SKILLS,
    orderNumber: 0,
    parentId: EMenuId.MASTER_DATA,
    description: '',
    text: 'Skill',
    pageTitle: 'Manage Skill',
    path: EPathname.MANAGE_SKILL,
    icon: null,
    route: <Route path={EPathname.MANAGE_SKILL} component={ViewSkills}/>,
    routeMenu: <Route path={EPathname.MANAGE_SKILL} component={() => ChangeHeader('Manage Skill')}/>,
  },
  {
    id: EMenuId.USER_AUTHENTICATION,
    orderNumber: 17,
    parentId: null,
    type: 'icon-text',
    text: 'User Auth',
    pageTitle: 'User Authentication',
    path: EPathname.USER_AUTHENTICATION,
    icon: <FmlxIcon name="Users"/>,
    route: <Route path={EPathname.USER_AUTHENTICATION} component={UserAuthentication}/>,
    routeMenu: <Route path={EPathname.USER_AUTHENTICATION} component={() => ChangeHeader('User Authentication')}/>,
  },
  {
    id: EMenuId.MANAGE_ROLE_LEVEL,
    orderNumber: 14,
    parentId: EMenuId.MASTER_DATA,
    description: '',
    text: 'Role Level',
    pageTitle: 'Manage Role Level',
    path: EPathname.MANAGE_ROLE_LEVEL,
    icon: null,
    route: <Route path={EPathname.MANAGE_ROLE_LEVEL} component={ManageRoleLevel}/>,
    routeMenu: <Route path={EPathname.MANAGE_ROLE_LEVEL} component={() => ChangeHeader('Manage Role Level')}/>,
  },
  {
    id: 0,
    orderNumber: 0,
    parentId: EMenuId.MASTER_DATA,
    description: '',
    text: 'Company',
    pageTitle: 'Manage Company',
    path: EPathname.MANAGE_COMPANY,
    icon: null,
    route: <Route path={EPathname.MANAGE_COMPANY} component={ManageCompany}/>,
    routeMenu: <Route path={EPathname.MANAGE_COMPANY} component={() => ChangeHeader('Manage Company')}/>,
  },
  // {
  //   id: EMenuId.MANAGE_DEPARTMENTS,
  //   orderNumber: 11,
  //   parentId: EMenuId.MASTER_DATA,
  //   description: '',
  //   text: "Department",
  //   pageTitle: "Manage Department",
  //   path: "/ManageDepartment",
  //   icon: null,
  //   route: <Route path="/ManageDepartment" component={ManageDepartments} />,
  //   routeMenu: <Route path="/ManageDepartment" component={() => ChangeHeader("Manage Department")} />,
  // },
  {
    id: EMenuId.MANAGE_PRACTICES,
    orderNumber: 12,
    parentId: EMenuId.MASTER_DATA,
    description: '',
    text: 'Practice',
    pageTitle: 'Manage Practice',
    path: EPathname.MANAGE_PRACTICES,
    icon: null,
    route: <Route path={EPathname.MANAGE_PRACTICES} component={ManagePractices}/>,
    routeMenu: <Route path={EPathname.MANAGE_PRACTICES} component={() => ChangeHeader('Manage Practice')}/>,
  },
  // {
  //   id: EMenuId.MANAGE_ROLE,
  //   orderNumber: 13,
  //   parentId: EMenuId.MASTER_DATA,
  //   description: '',
  //   text: "Role",
  //   pageTitle: "Manage Role",
  //   path: "/ManageRole",
  //   icon: null,
  //   route: <Route path="/ManageRole" component={() => <></>} />,
  //   routeMenu: <Route path="/ManageRole" component={() => ChangeHeader("Manage Role")} />,
  // },
  {
    id: EMenuId.MANAGE_OFFICE,
    orderNumber: 17,
    parentId: EMenuId.MASTER_DATA,
    description: '',
    text: 'Office',
    pageTitle: 'Manage Office',
    path: EPathname.MANAGE_OFFICE,
    icon: null,
    route: <Route path={EPathname.MANAGE_OFFICE} component={ManageOffice}/>,
    routeMenu: <Route path={EPathname.MANAGE_OFFICE} component={() => ChangeHeader('Manage Project')}/>,
  },
  {
    id: EMenuId.MANAGE_PROJECTS,
    orderNumber: 18,
    parentId: EMenuId.MASTER_DATA,
    description: '',
    text: 'Project',
    pageTitle: 'Manage Project',
    path: EPathname.MANAGE_PROJECT,
    icon: null,
    route: <Route path={EPathname.MANAGE_PROJECT} component={ManageProjects}/>,
    routeMenu: <Route path={EPathname.MANAGE_PROJECT} component={() => ChangeHeader('Manage Project')}/>,
  },
  {
    id: EMenuId.MANAGE_PERIODS,
    orderNumber: 15,
    parentId: EMenuId.MASTER_DATA,
    description: '',
    text: 'Review Period',
    path: EPathname.MANAGE_PERIODS,
    pageTitle: 'Review Period',
    icon: null,
    route: <Route path={EPathname.MANAGE_PERIODS} component={ManagePeriods}/>,
    routeMenu: <Route path={EPathname.MANAGE_PERIODS} component={() => ChangeHeader('Review Period')}/>,
  },
  {
    id: EMenuId.MANAGE_EMPLOYEE,
    orderNumber: 9,
    parentId: EMenuId.MASTER_DATA,
    description: '',
    text: 'Employee',
    pageTitle: 'Manage Employee',
    path: EPathname.MANAGE_EMPLOYEE,
    icon: null,
    route: <Route path={EPathname.MANAGE_EMPLOYEE} component={ManageEmployee}/>,
    routeMenu: <Route path={EPathname.MANAGE_EMPLOYEE} component={() => ChangeHeader('Manage Employee')}/>,
  },
  {
    id: EMenuId.TEAM_ASSIGNMENT,
    orderNumber: 10,
    parentId: EMenuId.MASTER_DATA,
    description: '',
    pageTitle: 'Manage Team Assignment',
    text: 'Team Assignment',
    path: EPathname.TEAM_ASSIGNMENT,
    icon: null,
    route: <Route path={EPathname.TEAM_ASSIGNMENT} component={TeamAssignment}/>,
    routeMenu: <Route path={EPathname.TEAM_ASSIGNMENT} component={() => ChangeHeader('Team Assignment')}/>,
  },
  {
    id: EMenuId.MANAGE_DEPARTMENT_ROLE,
    orderNumber: 14,
    parentId: EMenuId.MASTER_DATA,
    description: '',
    text: 'Department Role',
    pageTitle: 'Manage Department Role',
    path: EPathname.MANAGE_DEPARTMENT_ROLE,
    icon: null,
    route: <Route path="/ManageDepartmentRole" component={ManageDepartmentRole}/>,
    routeMenu: <Route path="/ManageDepartmentRole" component={() => ChangeHeader('Manage Department Role')}/>,
  },
  {
    id: EMenuId.MESSAGE_INBOX,
    orderNumber: 21,
    parentId: EMenuId.MASTER_DATA,
    description: '',
    text: 'Message',
    pageTitle: 'Message',
    path: EPathname.MESSAGE_INBOX_MANAGER,
    icon: null,
    route: <Route path={EPathname.MESSAGE_INBOX_MANAGER} component={MessageInbox}/>,
    routeMenu: (
      <Route
        path="/MessageInbox/All"
        component={() => {
          ChangeHeader('Message Dropbox');
        }}
      />
    ),
  },
  {
    id: EMenuId.MESSAGE_INBOX_USER,
    orderNumber: 22,
    parentId: null,
    text: 'Message',
    pageTitle: 'Message',
    type: 'icon',
    icon: <FmlxIcon id="icon-message" customColor="{string}" name="Nt8SendMessage" />,
    path: EPathname.MESSAGE_INBOX_USER,
    route: <Route path={EPathname.MESSAGE_INBOX_USER} component={MessageInbox}/>,
    routeMenu: <Route path={EPathname.MESSAGE_INBOX_USER} component={() => ChangeHeader('Message Dropbox')}/>,
  },
  {
    id: EMenuId.LOGOUT,
    parentId: null,
    orderNumber: 15,
    text: 'Logout',
    pageTitle: 'Logout',
    type: 'icon',
    path: null,
    icon: <FmlxIcon name="Logout"/>,
    route: null,
    routeMenu: null,
  },
];
